/**
 * Mapa central de secciones del Instituto Tlaxcalteca de Elecciones (ITE)
 * Vincula las secciones del menú principal con la generación automática
 * de migas de pan en .page-hero y la sincronización del menú activo en NavbarMenu.
 */

export const SECTIONS = {
  "acerca-ite": {
    key: "acerca-ite",
    name: "Acerca de ITE",
    url: "/FinesInstitucionales",
    menuId: "acercaITE",
    paths: [
      "/finesinstitucionales",
      "/historia",
      "/principiosrectores",
      "/estructuraorganica",
    ],
  },
  "consejo-general": {
    key: "consejo-general",
    name: "Consejo General",
    url: "/Integracion",
    menuId: "consejoGeneral",
    paths: [
      "/integracion",
      "/comisiones",
      "/jge",
      "/estructura",
    ],
  },
  "acuerdos": {
    key: "acuerdos",
    name: "Acuerdos",
    url: "/Acuerdos2026",
    menuId: "acuerdos",
    paths: [
      "/acuerdosanteriores",
      "/acuerdostableite",
      "/acuerdos1998",
      "/acuerdos20",
      "/acuerdosine",
      "/acuerdostableine",
    ],
  },
  "demarcaciones": {
    key: "demarcaciones",
    name: "Demarcaciones",
    url: "/Mapas",
    menuId: "demarcaciones",
    paths: [
      "/mapas",
      "/mapaspj",
      "/acuerdos",
      "/acuerdospj",
      "/distritacion",
    ],
  },
  "transparencia": {
    key: "transparencia",
    name: "Transparencia",
    url: "/Transparencia",
    menuId: "transparencia",
    paths: [
      "/transparencia",
      "/infografias",
      "/preguntasfrecuentes",
      "/datosabiertos",
      "/articulo",
      "/art",
      "/obligaciones",
      "/tablaa",
      "/poaa",
      "/poa",
      "/informacionfinanciera",
      "/informacioncontable",
      "/convenios",
      "/avisosprivacidad",
      "/avisos",
      "/formatosolicitud",
      "/informesanuales",
      "/section",
      "/planes",
    ],
  },
  "comunicacion-social": {
    key: "comunicacion-social",
    name: "Comunicación Social",
    url: "/Boletines2026",
    menuId: "comunicacionSocial",
    paths: [
      "/boletines",
      "/monitoreos",
      "/iteconecta",
      "/encorto",
      "/galeria",
    ],
  },
  "cultura-civica": {
    key: "cultura-civica",
    name: "Cultura Cívica",
    url: "/ActividadesLudicas",
    menuId: "culturaCivica",
    paths: [
      "/actividadesludicas",
      "/eleccionesescolares",
      "/parlamentoinfantil",
      "/parlamentojuvenil",
      "/valoresdemocracia",
    ],
  },
  "archivo": {
    key: "archivo",
    name: "Archivo",
    url: "/InstrumentosNormativos",
    menuId: "archivo",
    paths: [
      "/instrumentosnormativos",
      "/planeacionarchivistica",
      "/instrumentosarchivisticos",
      "/inventariosdocumentales",
      "/infografiasarchivo",
    ],
  },
  "licitaciones": {
    key: "licitaciones",
    name: "Licitaciones",
    url: "/Licitaciones",
    menuId: "licitaciones",
    paths: [
      "/licitaciones",
    ],
  },
  "encuesta-satisfaccion": {
    key: "encuesta-satisfaccion",
    name: "Encuesta de Satisfacción",
    url: "https://encuesta-satisfaccion.itetlax.org.mx/",
    menuId: "encuestaSatisfaccion",
    paths: [],
  },

  /* Secciones complementarias para enlaces especiales del sitio */
  "procesos-electorales": {
    key: "procesos-electorales",
    name: "Procesos Electorales",
    url: "/ProcesosElectorales",
    menuId: null,
    paths: [
      "/procesoselectorales",
      "/historialpe",
      "/pe20152016",
      "/pee2017",
      "/pe2018",
      "/pe20202021",
      "/pe20232024",
      "/pepj20242025",
      "/proceso-ordinario",
      "/proceso-extraordinario",
    ],
  },
  "oic": {
    key: "oic",
    name: "Órgano Interno de Control",
    url: "/OIC",
    menuId: null,
    paths: [
      "/oic",
      "/galeriaoic",
      "/acuerdosoic",
    ],
  },
  "estrados-electronicos": {
    key: "estrados-electronicos",
    name: "Estrados Electrónicos",
    url: "/EstradosElectronicos",
    menuId: null,
    paths: [
      "/estradoselectronicos",
    ],
  },
  "memorias-electorales": {
    key: "memorias-electorales",
    name: "Memorias Electorales",
    url: "/MemoriasElectorales",
    menuId: null,
    paths: [
      "/memoriaselectorales",
      "/memoriaelectoral20202021",
    ],
  },
  "convocatorias": {
    key: "convocatorias",
    name: "Convocatorias",
    url: "/ConvocatoriasApartado",
    menuId: null,
    paths: [
      "/convocatoriasapartado",
    ],
  },
  "directorio": {
    key: "directorio",
    name: "Directorio",
    url: "/Directorio",
    menuId: null,
    paths: [
      "/directoriopage",
      "/directorio",
    ],
  },
};

/**
 * Busca una sección por clave (ej. "acerca-ite"), nombre ("Acerca de ITE")
 * o por ruta actual (pathname, ej. "/FinesInstitucionales")
 * @param {string} sectionKeyOrPath
 * @returns {object|null}
 */
export const getSection = (sectionKeyOrPath) => {
  if (!sectionKeyOrPath || typeof sectionKeyOrPath !== "string") {
    return null;
  }

  const raw = sectionKeyOrPath.trim();
  const normalized = raw.toLowerCase();

  // 1. Búsqueda por clave exacta
  if (SECTIONS[normalized]) {
    return SECTIONS[normalized];
  }

  // 2. Búsqueda por nombre de sección
  for (const key in SECTIONS) {
    const sec = SECTIONS[key];
    if (sec.name && sec.name.toLowerCase() === normalized) {
      return sec;
    }
  }

  // 3. Comparación por clave simplificada (sin guiones o espacios)
  const cleanKey = normalized.replace(/[\s_-]+/g, "");
  for (const key in SECTIONS) {
    if (key.replace(/-/g, "") === cleanKey) {
      return SECTIONS[key];
    }
  }

  // 4. Casos específicos de desambiguación de rutas
  if (normalized.startsWith("/estructuraorganica")) {
    return SECTIONS["acerca-ite"];
  }

  if (
    normalized === "/acuerdos" ||
    normalized.startsWith("/mapas") ||
    normalized.startsWith("/acuerdospj") ||
    normalized.startsWith("/distritacion")
  ) {
    return SECTIONS["demarcaciones"];
  }

  if (
    normalized.startsWith("/acuerdos") &&
    !normalized.startsWith("/acuerdospj") &&
    normalized !== "/acuerdos"
  ) {
    return SECTIONS["acuerdos"];
  }

  // 5. Búsqueda por coincidencia de prefijo de ruta
  for (const key in SECTIONS) {
    const sec = SECTIONS[key];
    if (sec.paths && sec.paths.some((p) => matchesPathPattern(normalized, p))) {
      return sec;
    }
  }

  return null;
};

/**
 * Comprueba si una ruta coincide con un patrón registrado.
 * Maneja coincidencia exacta, subrutas (/ruta/...) y prefijos dinámicos (ej. /boletines2026),
 * evitando colisiones entre palabras compuestas como /estructura vs /estructuraorganica.
 */
const matchesPathPattern = (currentPath, registeredPath) => {
  if (currentPath === registeredPath) return true;
  if (currentPath.startsWith(registeredPath + "/")) return true;

  // Desambiguar /estructura (Consejo General) de /estructuraorganica (Acerca de ITE)
  if (registeredPath === "/estructura" && currentPath.startsWith("/estructuraorganica")) {
    return false;
  }

  return currentPath.startsWith(registeredPath);
};

/**
 * Comprueba si la ruta actual pertenece a una sección específica
 * Útil para sincronizar la clase activa en NavbarMenu.js
 * @param {string} currentPath
 * @param {string} sectionKey
 * @returns {boolean}
 */
export const isSectionActive = (currentPath, sectionKey) => {
  if (!currentPath || !sectionKey) return false;
  const path = currentPath.toLowerCase();

  // Desambiguación Demarcaciones vs Acuerdos
  if (sectionKey === "demarcaciones") {
    return (
      path === "/acuerdos" ||
      path.startsWith("/mapas") ||
      path.startsWith("/mapaspj") ||
      path.startsWith("/acuerdospj") ||
      path.startsWith("/distritacion")
    );
  }

  if (sectionKey === "acuerdos") {
    return (
      path.startsWith("/acuerdos") &&
      !path.startsWith("/acuerdospj") &&
      path !== "/acuerdos"
    );
  }

  // Desambiguación Acerca de ITE vs Consejo General
  if (sectionKey === "consejo-general" && path.startsWith("/estructuraorganica")) {
    return false;
  }

  if (sectionKey === "acerca-ite" && path.startsWith("/estructuraorganica")) {
    return true;
  }

  const sec = SECTIONS[sectionKey];
  if (!sec || !sec.paths) return false;
  return sec.paths.some((p) => matchesPathPattern(path, p));
};

export default SECTIONS;
